// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:base-models --tenant projectReplica` to regenerate.
import DatabaseRecord from "velocious/build/src/database/record/index.js"

/**
 * Attributes accepted when creating or updating BoardColumn records.
 * @typedef {object} BoardColumnWriteAttributes
 * @property {string} [id] - Value for the id attribute.
 * @property {string} [boardId] - Value for the boardId attribute.
 * @property {string} [name] - Value for the name attribute.
 * @property {string | null} [color] - Value for the color attribute.
 * @property {number} [position] - Value for the position attribute.
 * @property {Date | string} [createdAt] - Value for the createdAt attribute.
 * @property {Date | string} [updatedAt] - Value for the updatedAt attribute.
 * @property {Date | string | null} [lastSyncChangeAt] - Value for the lastSyncChangeAt attribute.
 * @property {import("../models/board.js").default} [board] - Related board record.
 */

/** @augments {DatabaseRecord<BoardColumnWriteAttributes>} */
export default class BoardColumnBase extends DatabaseRecord {
  /** @returns {typeof import("../models/board-column.js").default} */
  // @ts-ignore - override narrows return type for better IntelliSense in generated model bases
  getModelClass() { return /** @type {typeof import("../models/board-column.js").default} */ (this.constructor) }

  /** @returns {string} */
  id() { return this.readAttribute("id") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setId(newValue) { return this._setColumnAttribute("id", newValue) }

  /** @returns {boolean} */
  hasId() { return this._hasAttribute(this.id()) }

  /** @returns {string} */
  boardId() { return this.readAttribute("boardId") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setBoardId(newValue) { return this._setColumnAttribute("boardId", newValue) }

  /** @returns {boolean} */
  hasBoardId() { return this._hasAttribute(this.boardId()) }

  /** @returns {string} */
  name() { return this.readAttribute("name") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setName(newValue) { return this._setColumnAttribute("name", newValue) }

  /** @returns {boolean} */
  hasName() { return this._hasAttribute(this.name()) }

  /** @returns {string | null} */
  color() { return this.readAttribute("color") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setColor(newValue) { return this._setColumnAttribute("color", newValue) }

  /** @returns {boolean} */
  hasColor() { return this._hasAttribute(this.color()) }

  /** @returns {number} */
  position() { return this.readAttribute("position") }

  /**
   * @param {number} newValue
   * @returns {void}
   */
  setPosition(newValue) { return this._setColumnAttribute("position", newValue) }

  /** @returns {boolean} */
  hasPosition() { return this._hasAttribute(this.position()) }

  /** @returns {Date} */
  createdAt() { return this.readAttribute("createdAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setCreatedAt(newValue) { return this._setColumnAttribute("createdAt", newValue) }

  /** @returns {boolean} */
  hasCreatedAt() { return this._hasAttribute(this.createdAt()) }

  /** @returns {Date} */
  updatedAt() { return this.readAttribute("updatedAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setUpdatedAt(newValue) { return this._setColumnAttribute("updatedAt", newValue) }

  /** @returns {boolean} */
  hasUpdatedAt() { return this._hasAttribute(this.updatedAt()) }

  /** @returns {Date | null} */
  lastSyncChangeAt() { return this.readAttribute("lastSyncChangeAt") }

  /**
   * @param {Date | string | null} newValue
   * @returns {void}
   */
  setLastSyncChangeAt(newValue) { return this._setColumnAttribute("lastSyncChangeAt", newValue) }

  /** @returns {boolean} */
  hasLastSyncChangeAt() { return this._hasAttribute(this.lastSyncChangeAt()) }

  /**
   * @returns {import("../models/board.js").default}
   */
  board() { return /** @type {import("../models/board.js").default} */ (this.getRelationshipByName("board").loaded()) }

  /**
   * @abstract
   * @param {ConstructorParameters<typeof import("../models/board.js").default>[0]} [attributes]
   * @returns {import("../models/board.js").default}
   */
  buildBoard(attributes) { void attributes; throw new Error("Not implemented") }

  /**
   * @abstract
   * @returns {Promise<import("../models/board.js").default | undefined>}
   */
  loadBoard() { throw new Error("Not implemented") }

  /**
   * @returns {Promise<import("../models/board.js").default | undefined>}
   */
  boardOrLoad() { return /** @type {Promise<import("../models/board.js").default | undefined>} */ (this.relationshipOrLoad("board")) }

  /**
   * @abstract
   * @param {import("../models/board.js").default} newModel
   * @returns {void}
   */
  setBoard(newModel) { void newModel; throw new Error("Not implemented") }

  /**
   * @returns {import("velocious/build/src/database/record/instance-relationships/has-many.js").default<typeof import("../models/board-column.js").default, typeof import("../models/task-board.js").default>}
   */
  taskBoards() { return /** @type {import("velocious/build/src/database/record/instance-relationships/has-many.js").default<typeof import("../models/board-column.js").default, typeof import("../models/task-board.js").default>} */ (this.getRelationshipByName("taskBoards")) }

  /**
   * @returns {Array<import("../models/task-board.js").default>}
   */
  taskBoardsLoaded() { return /** @type {Array<import("../models/task-board.js").default>} */ (this.getRelationshipByName("taskBoards").loaded()) }

  /**
   * @abstract
   * @returns {Promise<Array<import("../models/task-board.js").default>>}
   */
  loadTaskBoards() { throw new Error("Not implemented") }

  /**
   * @returns {Promise<Array<import("../models/task-board.js").default>>}
   */
  taskBoardsOrLoad() { return /** @type {Promise<Array<import("../models/task-board.js").default>>} */ (this.relationshipOrLoad("taskBoards")) }

  /**
   * @abstract
   * @param {Array<import("../models/task-board.js").default>} newModels
   * @returns {void}
   */
  setTaskBoards(newModels) { void newModels; throw new Error("Not implemented") }
}
